import { Injectable } from '@angular/core';
import * as Rx from 'rxjs/Rx';

@Injectable()
export class WebsocketService {

  constructor() { }

  private subject: Rx.Subject<MessageEvent>;
  private ws: WebSocket;

  dataStack: any[] = [];

  public connect(url): Rx.Subject<MessageEvent> {
    if (!this.subject) {
      this.subject = this.create(url);
      
    }
    return this.subject;
  } 

  public reconnect(url): Rx.Subject<MessageEvent> {
    this.closeCurrent();
    this.subject = null;
    return this.create(url);
  }

  public isSocketClosed() {
    return this.ws.readyState == WebSocket.CLOSED || this.ws.readyState == WebSocket.CLOSING;
  }

  private create(url): Rx.Subject<MessageEvent> {
    this.ws = new WebSocket(url);
    
     let observable = Rx.Observable.create(
      (obs: Rx.Observer<MessageEvent>) => {
        this.ws.onmessage = obs.next.bind(obs);
        this.ws.onerror = obs.error.bind(obs);
        this.ws.onclose = obs.complete.bind(obs);
        return this.ws.close.bind(this.ws);
      }
    )


    let observer = {
      next: (data: Object) => {
        if (this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify(data));
        }
        else {
          this.dataStack.push(data);
          this.ws.onopen = (evt) => {
            for (let i = 0; i < this.dataStack.length; i++) {
              this.ws.send(JSON.stringify(this.dataStack[i]));
            }
            this.dataStack = [];
          };
        }
        
        }
      }
      return Rx.Subject.create(observer, observable);
  }

  private closeCurrent() {
    this.ws.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/websocket.service.ts